import '@angular/compiler';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { ComponentMiddleComponent } from './component.middle/component.middle.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageMainComponent } from './page.main/page.main.component';
import { ComponentBottomComponent } from './component.bottom/component.bottom.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { ComponentTopComponent } from './component.top/component.top.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PortalSeasonLoadingHexaComponent,
        PortalSeasonViewerTreeComponent,
        PortalSeasonUiDropdownComponent,
        PortalSeasonPagenationComponent,
        PortalSeasonLoadingComponent,
        ComponentMiddleComponent,
        PortalSeasonLoadingSeasonComponent,
        PageMainComponent,
        ComponentBottomComponent,
        PortalSeasonStatusbarComponent,
        ComponentTopComponent,
        PortalSeasonAlertComponent,
        LayoutNavbarComponent,
        PortalSeasonTabComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }